var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('div',_vm._l((_vm.errors),function(error){return _c('small',{key:error,staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(error)+"\n    ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }